import config from '../config';

import {getRoutesForStoreType} from './routes/routes';
import {RouteSpec, StoreType} from './routes/types';
import {isRouteEntryVisibleForLoggedInState} from './util';

export type DrawerEntriesArgs = {
  storeType: StoreType;
  storeLoyaltyEnabled: boolean;
  ecommerceDisabled?: boolean;
  isLoggedIn: boolean;
};

export const GO_BACK_TO_STORE_LABEL = 'Go back to the store';
export const LOG_OUT_LABEL = 'Log out';

const sortDrawerRoutesBySortOrder = (a: RouteSpec, b: RouteSpec) =>
  (a.drawerSortOrder || 0) - (b.drawerSortOrder || 0);

/**
 * The drawer's route rows: its filter and sort, moved here unchanged (DIS-1898 B9).
 * `getRoutesForStoreType` gets 3 arguments, as the drawer always called it, so its
 * `isLoggedIn` keeps its default; `isLoggedIn` only filters `requiresLogin` / `requiresLogout`.
 */
export const drawerEntries = ({
  storeType,
  storeLoyaltyEnabled,
  ecommerceDisabled,
  isLoggedIn,
}: DrawerEntriesArgs): RouteSpec[] =>
  getRoutesForStoreType(storeType, storeLoyaltyEnabled, ecommerceDisabled)
    .filter(({showInDrawer}) => showInDrawer)
    .filter(isRouteEntryVisibleForLoggedInState(isLoggedIn))
    .sort(sortDrawerRoutesBySortOrder);

/** The drawer footer's "Go back to the store" row. */
export const showGoBackToStore = (storeType: StoreType): boolean =>
  !!(config.FF_IS_GIFT_CARDS_ENABLED && storeType === StoreType.GiftCardStore);
